var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 2.625C17.1723 2.62952 13.5027 4.15206 10.7961 6.85863C8.08956 9.56521 6.56702 13.2348 6.56251 17.0625C6.55899 20.1903 7.58062 23.2331 9.47101 25.725C9.47101 25.725 9.86476 26.2434 9.92907 26.3183L21 39.375L32.0762 26.3117C32.1339 26.2421 32.529 25.725 32.529 25.725L32.5303 25.7211C34.4194 23.2301 35.4405 20.1888 35.4375 17.0625C35.433 13.2348 33.9105 9.56521 31.2039 6.85863C28.4973 4.15206 24.8277 2.62952 21 2.625ZM21 22.3125C19.9617 22.3125 18.9466 22.0046 18.0833 21.4277C17.2199 20.8508 16.547 20.0309 16.1496 19.0716C15.7523 18.1123 15.6483 17.0567 15.8509 16.0383C16.0535 15.0199 16.5535 14.0844 17.2877 13.3502C18.0219 12.616 18.9574 12.1159 19.9758 11.9134C20.9942 11.7108 22.0498 11.8148 23.0091 12.2121C23.9684 12.6095 24.7883 13.2824 25.3652 14.1458C25.9421 15.0091 26.25 16.0241 26.25 17.0625C26.2483 18.4544 25.6946 19.7887 24.7104 20.7729C23.7262 21.7571 22.3919 22.3108 21 22.3125Z",
    fill: "#F03A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.7167578b4672d3ada539cb9216066c89.svg";
export { ForwardRef as ReactComponent };